module.exports = __webpack_public_path__ + "static/img/hero3_info.6434e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero3_info.png
// module id = PMee
// module chunks = 1